import { render } from "./LearningGoalsAllComponent.vue?vue&type=template&id=45eb7354&scoped=true"
import script from "./LearningGoalsAllComponent.vue?vue&type=script&lang=js"
export * from "./LearningGoalsAllComponent.vue?vue&type=script&lang=js"

import "./LearningGoalsAllComponent.vue?vue&type=style&index=0&id=45eb7354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45eb7354"]])

export default __exports__